export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";